import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Form, Image, Select, Input, Button, Table, Row, Col } from 'antd'
import baseAxios, { baseAxiosNoInfo } from '../../tool/axios'

const { Option } = Select
const { Column } = Table

const formItemLayout = {
    labelCol: { span: 3 },
    wrapperCol: { span: 12 }
}

export default function CkOrderDetail() {

    const [orderData, setOrderData] = useState<any>()

    const [emp1, setEmp1] = useState<any[]>([])
    const [emp2, setEmp2] = useState<any[]>([])

    const [giftCh, setGiftCh] = useState<any[]>([])
    const [buyList, setBuyList] = useState<any[]>([])
    const [giftYz, setGiftYz] = useState<any[]>([])

    const [payList, setPayList] = useState<any[]>([])
    const [payRecords, setPayRecords] = useState<any[]>([])

    const [formInfoRef] = Form.useForm()
    const [selectType, setSelectType] = useState<number>(0)

    let { id, type }: { id: string | undefined, type: string | undefined } = useParams()

    useEffect(() => {
        initData()
    }, [])

    const initData = () => {
        baseAxiosNoInfo.get('/chankang_center/order_list/detail', { params: { order_id: id } }).then((res: any) => {
            if (res) {
                setOrderData(res)

                setEmp1(res.employee_adviser_list || [])
                setEmp2(res.employee_recover_list || [])

                setGiftCh(res.gift_chankang_item_list)
                setBuyList(res.buy_item_list)
                setGiftYz(res.gift_yuezi_item_list)

                setPayList(res.pay_pic_list.split(","))
                setPayRecords(res.pay_records)
            }
        })
    }

    const handleSelectChange = (value: any) => {
        setSelectType(value)
    }

    const submitAudit = (value: any) => {
        let data = {
            order_id: id,
            review_status: value.review_status,
            review_refuse_reason: value.review_refuse_reason
        }

        baseAxios.post('/finance_center/chankang/pay_records/review', data).then(res => {
            initData()
        })
    }

    return <div className="common-level2-edit">
        {/* 产康中心 -> 产康项目管理 -> 产康订单管理 -> 订单详情 */}
        <h2>订单详情</h2>

        <div className="clear" style={{ paddingLeft: 16, marginBottom: 16 }} >
            <Button size="small" onClick={() => { window.history.go(-1) }} >返回</Button>
        </div>

        <div className="sections-content">
            <div className="common-main">
                <Form {...formItemLayout} >
                    <Form.Item label="门店" >
                        {orderData?.store_name}
                    </Form.Item>

                    <Form.Item label="签单人"   >
                        <h4 style={{ fontWeight: 'bold', fontSize: 16 }}>产康顾问</h4>
                        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                            {emp1.map((el) => <li style={{ textIndent: '1em', marginBottom: 10 }}> <span>{el.user_name}</span> - <span>{el.results_proportion}%</span> </li>)}
                        </ul>

                        <div className="line" style={{ marginTop: 20, marginBottom: 20, width: '30%', border: '1px dashed #999', height: 0 }}></div>

                        <h4 style={{ fontWeight: 'bold', fontSize: 16 }}>产康师</h4>
                        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                            {emp2.map((el) => <li style={{ textIndent: '1em', marginBottom: 10 }}> <span>{el.user_name}</span> - <span>{el.results_proportion}%</span> </li>)}
                        </ul>
                    </Form.Item>

                    <Form.Item label="客户名称"  >
                        {orderData?.customer_name}
                    </Form.Item>
                    <Form.Item label="客户手机号"  >
                        {orderData?.customer_phone}
                    </Form.Item>

                    <Form.Item label="下单时间"  >
                        {orderData?.create_date}
                    </Form.Item>
                    <Form.Item label="订单编号"  >
                        {orderData?.order_code}
                    </Form.Item>
                    <Form.Item label="订单状态"  >
                        {orderData?.order_status_desc}
                    </Form.Item>

                    <Form.Item label="审核状态"  >
                        {orderData?.review_status == 0 ? '未审核' : (orderData?.review_status == 1 ? '审核通过' : '审核未通过')}
                    </Form.Item>
                    {orderData?.review_refuse_reason && <Form.Item label="审核不通过原因"  >
                        {orderData?.review_refuse_reason}
                    </Form.Item>}
                </Form>

                {/* type == 1，从财务模块的产康收款管理穿透过来的 */}
                {type == 'true' && orderData?.review_status == 0 &&
                    <Form form={formInfoRef} onFinish={submitAudit} {...formItemLayout}>
                        <Form.Item label="审核" rules={[{ required: true, message: '请选择审核状态' }]} name="review_status">
                            <Select style={{ width: 120 }} placeholder="请选择" onChange={handleSelectChange}>
                                <Option value={1}>审核通过</Option>
                                <Option value={2}>审核不通过</Option>
                            </Select>
                        </Form.Item>

                        {selectType == 2 && <Form.Item label="审核不通过原因" rules={[{ required: true, message: '请填写审核不通过原因' }]} name="review_refuse_reason">
                            <Input.TextArea />
                        </Form.Item>}

                        <Form.Item wrapperCol={{ span: 12, offset: 5 }}>
                            <Button type="primary" htmlType="submit">提交</Button>
                        </Form.Item>
                    </Form>}
            </div>
        </div>

        <h2>付款信息</h2>
        <div className="common-main">
            <Form {...formItemLayout} >
                <Form.Item label="订单金额">
                    {orderData?.init_deal_amount ? orderData?.init_deal_amount : 0}
                </Form.Item>

                <Form.Item label="收款金额">
                    {orderData?.actually_deal_amount ? orderData?.actually_deal_amount : 0}
                </Form.Item>

                <Form.Item label="收款凭证" name='agreementList' >
                    {payList.map((item: any, index: any) => (<Image key={index} width={200} src={item} />))}
                </Form.Item>

                <Form.Item label="收款时间"  >
                    {orderData?.create_date}
                </Form.Item>

                <Form.Item label="收款状态"  >
                    {orderData?.order_status_desc}
                </Form.Item>

                <Form.Item label="备注"  >
                    {orderData?.remark ? orderData?.remark : '--'}
                </Form.Item>

                <Form.Item label="付款明细"  >
                    <Table dataSource={payRecords} scroll={{ x: 'max-content' }} bordered={true} pagination={false} rowKey="customer_id">
                        <Column title="付款方式" dataIndex="pay_way_desc" key="pay_way_desc" />
                        <Column title="付款金额" dataIndex="pay_amount" key="pay_amount" />
                        <Column title="付款时间" dataIndex="deal_date" key="deal_date" />
                        <Column title="录入人" dataIndex="create_user_name" key="create_user_name" />
                    </Table>
                </Form.Item>
            </Form>
        </div>

        <h2>购买信息</h2>
        <div style={{ paddingLeft: '50px', paddingBottom: '20px' }}>
            <h3 style={{ paddingLeft: '20px', fontWeight: 'bold' }}>产康购买</h3>
            <Table dataSource={buyList} scroll={{ x: 'max-content' }} bordered={true} pagination={false} rowKey="customer_id" style={{ width: '95%' }}>
                <Column title="项目类型" dataIndex="chankang_item_type_desc" key="chankang_item_type_desc" />
                <Column title="项目名称" dataIndex="item_name" key="item_name" />
                <Column title="项目次数" dataIndex="count" key="count" />
                <Column title="金额(元)" dataIndex="total_amount" key="total_amount" />
            </Table>
        </div>

        <div style={{ paddingLeft: '50px', paddingBottom: '20px' }}>
            <h3 style={{ paddingLeft: '20px', fontWeight: 'bold' }}>产康赠送</h3>
            <Table dataSource={giftCh} scroll={{ x: 'max-content' }} bordered={true} pagination={false} rowKey="customer_id" style={{ width: '95%' }}>
                <Column title="项目类型" dataIndex="chankang_item_type_desc" key="chankang_item_type_desc" />
                <Column title="项目名称" dataIndex="item_name" key="item_name" />
                <Column title="项目次数" dataIndex="count" key="deal_date" />
            </Table>
        </div>

        <div style={{ paddingLeft: '50px', paddingBottom: '20px' }}>
            <h3 style={{ paddingLeft: '20px', fontWeight: 'bold' }}>月子赠送</h3>
            <Table dataSource={giftYz} scroll={{ x: 'max-content' }} bordered={true} pagination={false} rowKey="customer_id" style={{ width: '95%' }}>
                <Column title="项目类型" dataIndex="chankang_item_type_desc" key="chankang_item_type_desc" />
                <Column title="项目名称" dataIndex="item_name" key="item_name" />
                <Column title="项目次数" dataIndex="count" key="deal_date" />
            </Table>
        </div>
    </div>
}